import { Link } from "react-router-dom";
import { useSEO } from "@/hooks/useSEO";

export default function LegalPageLayout({ title, path, description, children, testId }) {
  useSEO({ title: `${title} — Express Delivery`, description, path, isIndexable: true });

  return (
    <div className="min-h-screen bg-white px-4 md:px-8 py-14 max-w-3xl mx-auto" data-testid={testId}>
      <Link to="/" className="text-orange font-semibold text-sm" data-testid="legal-back-home">
        ← Retour à l'accueil
      </Link>
      <h1 className="font-heading font-bold text-3xl text-navy mt-6 mb-8">{title}</h1>
      <div className="space-y-6 text-sm text-muted-foreground leading-relaxed">{children}</div>
    </div>
  );
}

export function LegalSection({ title, children }) {
  return (
    <section>
      <h2 className="font-heading font-semibold text-navy text-lg mb-2">{title}</h2>
      {children}
    </section>
  );
}
